import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatDialogCloseEvent, Role as RoleMaster } from '../../../../const';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Role, RolePayload } from '../../../../models/role.model';
import { PackageService } from '../../../package-center/package/package.service';
import { DtoFeature, DtoModule, DtoPackage, DtoPackageModule, DtoPreviewItem, DtoSubCategory } from '../../../../models/package-center.model';
import { ProdetailsModalComponent } from '../../../data-management/prodetails-modal/prodetails-modal.component';
import { SchoolService } from '../../../school/school.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-edit-user-role',
  templateUrl: './edit-user-role.component.html'
})
export class EditUserRoleComponent implements OnInit {

  roleData = {} as Role;
  roleForm = new FormGroup({
    roleId: new FormControl(0),
    roleName: new FormControl('', [
      Validators.required,
      Validators.pattern('^.*[a-zA-Z]+.*$ ?'),
    ]),
    
    features: new FormControl([] as DtoFeature[]),
    modules: new FormControl([] as DtoModule[], [
      Validators.required
    ]),
    subCategories: new FormControl([] as DtoSubCategory[], [
      Validators.required
    ])
  });

  features:DtoFeature[] = [];
  availableGroupedFeatures: { [key: string]: DtoFeature[] } = {};
  groupedFeatures: { [key: string]: DtoFeature[] } = {};

  subCategories: DtoSubCategory[] = [];
  availableGroupedSubCategories: { [key: string]: DtoSubCategory[] } = {};
  groupedSubCategories: { [key: string]: DtoSubCategory[] } = {};

  modules: DtoModule[] = [];
  package: DtoPackage = {} as DtoPackage;
  packageId: number = 0;
  editUserDetail: boolean = false;
  clientAccountId: number = 0;
  schoolId: any;
  canEditName: boolean = false;
  SystemRolesTypes = RoleMaster;

  constructor(
    @Optional() private dialogRef: MatDialogRef<EditUserRoleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private toasterService: ToastrService,
    private packageService: PackageService,
    private dialog: MatDialog,
    private schoolService: SchoolService
  ) {}

  ngOnInit(): void {
    if(this.data.role.roleId){
      this.roleData = this.data.role;
      this.editUserDetail = this.data.editUserDetail;
      this.roleForm.patchValue(this.roleData);
      this.clientAccountId = Number(this.data.clientAccountId);
    }
    this.schoolId = this.data.schoolId;
    this.packageId = this.data.packageId;
    this.clientAccountId = Number(this.data.clientAccountId);
    this.getPackageByPackageId(this.packageId);

    const hasRoleId = (this.roleForm.controls['roleId'].value && this.roleForm.controls['roleId'].value > 0) as boolean;
    this.canEditName = !hasRoleId;
    if(!this.canEditName){
       const userRole = sessionStorage.getItem('user_role')?.split(',')!;
      if(userRole.includes(this.SystemRolesTypes.SchoolAdmin) || userRole.includes(this.SystemRolesTypes.MatAdmin)){
        this.canEditName = true;
      }    
    }
  }
  
  _createGroupedFeatures(features: DtoFeature[]){
    return (features??[]).reduce((result, sc) => 
            {
              const key = sc.featureSetName;
              result[key] = result[key] || [];
              result[key].push(sc);
              return result;
            },{} as {[key:string]: DtoFeature[]});
  }
  
  createGroupedFeatures(features: DtoFeature[]){
    this.groupedFeatures = this._createGroupedFeatures(features)
  }

  _createGroupedValues(subCategories: DtoSubCategory[]){
    return (subCategories??[]).reduce((result, sc) => 
            {
              const key = sc.moduleDisplayName!;
              result[key] = result[key] || [];
              result[key].push(sc);
              return result;
            },{} as {[key:string]: DtoSubCategory[]});
  }

  createGroupedValues(subCategories: DtoSubCategory[]){
    this.groupedSubCategories = this._createGroupedValues(subCategories)
  }
  getPackageByPackageId(assignedPackageId: number) {
    this.packageService.getPackageByPackageId(assignedPackageId).subscribe((response: DtoPackage[] | any)=>{
      this.package = response[0];
      
      this.features=this.package.features;
      
      let featureList = this.features?.filter((feature: DtoFeature) => {
        return this.roleData?.features?.some((packageFeature: DtoFeature) => feature.featureId === packageFeature.featureId);
      });
      
      this.roleForm.controls['features'].setValue(featureList);
      this.groupedFeatures = this._createGroupedFeatures(featureList);
      this.availableGroupedFeatures = this._createGroupedFeatures(this.features);
      
      this.modules = this.package.modules.map((x: DtoPackageModule)=>{
        return{
          moduleId: x.moduleId,
          moduleName: x.moduleName
        } as DtoModule
      })
      let moduleList = this.modules?.filter((module: DtoModule) => {
        return this.roleData?.modules?.some((packageModule: DtoModule) => module.moduleId === packageModule.moduleId);
      });
      this.roleForm.controls['modules'].setValue(moduleList);
      let payload = this.roleData?.modules?.map((x: DtoModule) => ({
        moduleId: x.moduleId,
        moduleName: x.moduleName
      }))
      if(payload && payload.length){
        this.packageService.getSubCategoriesOfPackage(payload, this.packageId).subscribe((response: DtoSubCategory[] | any) => {
          this.subCategories = response
          this.availableGroupedSubCategories = this._createGroupedValues(this.subCategories);
          let subCategoryList = this.subCategories?.filter((subCategory: DtoSubCategory) => {
            return this.roleData?.subCategories?.some((packagesubCategory: DtoSubCategory) => subCategory.subCategoryId === packagesubCategory.subCategoryId);
          });
          this.roleForm.controls['subCategories'].setValue(subCategoryList);
          this.createGroupedValues(subCategoryList);
        },(err: HttpErrorResponse)=>{
          if(err.error){
            this.toasterService.error(err.error, "Error");
          }
        })
      }
    },(err: HttpErrorResponse)=>{
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    });
  }

  onModuleChange(selectedModule: any){
    let payload = selectedModule.value;
    this.packageService.getSubCategoriesOfPackage(payload, this.packageId).subscribe((response: DtoSubCategory[] | any) => {
      this.subCategories = response;
      this.availableGroupedSubCategories = this._createGroupedValues(this.subCategories);
      let subCategoryList: any = this.subCategories.filter((subCategory: DtoSubCategory) => {
        return this.roleForm.controls['subCategories'].value?.some((packagesubCategory: DtoSubCategory) => subCategory.subCategoryId === packagesubCategory.subCategoryId);
      });
      this.roleForm.controls['subCategories'].setValue(subCategoryList);
      this.createGroupedValues(subCategoryList);
    },(err: HttpErrorResponse)=>{
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    })
  }

  cancel() {
    this.dialogRef.close({ event: MatDialogCloseEvent.CANCELLED });
  }

  update(){
    let roleDetails = JSON.parse(JSON.stringify(this.roleForm.value));
    if(roleDetails.length){
      roleDetails.forEach((element: any) => {
        element.IsIndividualEntity = this.clientAccountId == 0 ;
      });
    }
    if(roleDetails.roleId){
      if(this.editUserDetail){
        let schoolId: number=0;
        if(!this.clientAccountId) {
          schoolId = this.schoolId && this.schoolId.length && this.schoolId.length == 1 ? this.schoolId[0] : this.schoolId
        }
        this.schoolService.createRole([roleDetails], this.clientAccountId, schoolId).subscribe((response: any)=>{
          if(response){
            this.toasterService.success("Role updated successfully","Success");
            let payload = {
              isIndividualEntity : this.clientAccountId == 0,
              clientAccountId : this.clientAccountId > 0 ? [this.clientAccountId] : [this.schoolId],
              roleId: response,
              pagination: {}
            } as RolePayload;
            this.schoolService.getRoles(payload, response).subscribe((roles: Role[] | any)=>{
            //this.schoolService.getRoles(this.clientAccountId, {} as Pagination, response).subscribe((roles: Role[] | any)=>{
              this.dialogRef.close({event:MatDialogCloseEvent.SUCCESS, data: roles[0]});
            })
          }
        },(err: HttpErrorResponse)=>{
          if(err.error){
            this.toasterService.error(err.error, "Error");
          }
        })
        return;
      }
      this.schoolService.updateRole(roleDetails).subscribe((response: any)=>{
        if(response){
          this.toasterService.success("Role updated successfully","Success");
          this.dialogRef.close({event:MatDialogCloseEvent.SUCCESS, data: roleDetails});
        }
      },(err: HttpErrorResponse)=>{
        if(err.error){
          this.toasterService.error(err.error, "Error");
        }
      });
    }
    else{
      let schoolId;
      if(!this.clientAccountId) {
        schoolId = this.schoolId && this.schoolId.length && this.schoolId.length == 1 ? this.schoolId[0] : this.schoolId
      }
      roleDetails.isIndividualEntity = this.clientAccountId == 0 ;
      roleDetails.individualSchoolId = roleDetails.isIndividualEntity ? this.schoolId : 0
      //this.clientAccountId = this.clientAccountId ? this.clientAccountId : this.schoolId;
      this.schoolService.createRole([roleDetails], this.clientAccountId, schoolId).subscribe((response: any)=>{
        if(response){
          this.toasterService.success("Role created successfully","Success");
          this.dialogRef.close({event:MatDialogCloseEvent.SUCCESS});
        }
      },(err: HttpErrorResponse)=>{
        if(err.error){
          this.toasterService.error(err.error, "Error");
        }
      })
    }
  }

  removeFeature(featureToRemove: DtoFeature){
    const featureList = 
      this.roleForm.controls['features'].value!.filter((x: DtoFeature)=>x.featureId != featureToRemove.featureId);
    this.roleForm.controls['features'].setValue(featureList);
    this.createGroupedFeatures(featureList);
  }
  removeSubCategory(SubCategoryToRemove: DtoSubCategory){
    const subCategoryList = 
      this.roleForm.controls['subCategories'].value!.filter((x: DtoSubCategory)=>x.subCategoryId != SubCategoryToRemove.subCategoryId);
    this.roleForm.controls['subCategories'].setValue(subCategoryList);
    this.createGroupedValues(subCategoryList);
  }

  removeModule(moduleToRemove: DtoModule){
    this.roleForm.controls['modules'].setValue(this.roleForm.controls['modules'].value!.filter((x: DtoModule)=>x.moduleId != moduleToRemove.moduleId));
    // if(!this.packageId){
      this.onModuleChange({value: this.roleForm.controls['modules'].value});
    // }
  }

  previewPopup(title: string, type: string){
    this.dialog.open(ProdetailsModalComponent,{
      width: '1000px',
      panelClass: 'modal-prodetails',
      data: {
        singleItemPreview: !!title,
        packageDetails: {},
        itemToPreview: type == 'Module' ? this.roleForm.controls['modules'].value!.map((x: DtoModule)=>({
          groupName: null,
          itemName: x.moduleName})) as DtoPreviewItem[]:
                                          this.roleForm.controls['subCategories'].value!.map((x: DtoSubCategory)=>({
                                            groupName: x.moduleDisplayName,
                                            itemName:x.subCategoryName})) as DtoPreviewItem[],
        title: title
      }
    })
  }
  
}
